require('./brokerAd.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { formatText } = require('core/i18n').i18n;

const BrokerAd = props => {
    const { myName, introText, moreLink, backgroundUrl } = props;
    const adMoreInfo = formatText('broker-moreInfo');
    const elementStyle = {
        backgroundImage: `url(${backgroundUrl})`
    };
    return (
        <div className="broker-ad" style={elementStyle}>
            <div className="broker-ad__title">
                {myName}
            </div>
            <p className="broker-ad__text">
                {introText}
            </p>
            <div className="broker-ad__separator"></div>
            <a className="broker-ad__link" href={moreLink}>
                {adMoreInfo}
            </a>

        </div>
    );
};

BrokerAd.propTypes = {
    myName: PropTypes.string,
    introText: PropTypes.string,
    moreLink: PropTypes.string,
    backgroundUrl: PropTypes.string
};

module.exports = BrokerAd;